// ChoralAuditTimeline.jsx
import React from "react";

function formatValue(v) {
  if (v == null) return "—";
  if (Array.isArray(v)) return v.join(", ");
  if (typeof v === "object") {
    try { return JSON.stringify(v); } catch { return String(v); }
  }
  return String(v);
}

export default function ChoralAuditTimeline({ audit = [] }) {
  return (
    <section className="ce-audit" data-testid="ce-audit-timeline">
      <h2>Editorial History</h2>
      {!audit.length ? (
        <p style={{ color: "var(--li-text-secondary, #5C5450)", fontStyle: "italic" }}>
          No editorial changes recorded.
        </p>
      ) : (
        <ol>
          {audit.map((entry) => (
            <li key={entry.id || entry._id} data-testid={`ce-audit-${entry.id || entry._id}`}>
              <div className="ce-audit__meta">
                <strong>{entry.kind || "edit"}</strong>
                <div>{entry.actor_type}</div>
                <div style={{ overflowWrap: "anywhere" }}>{entry.actor_id}</div>
                <time>{entry.timestamp && new Date(entry.timestamp).toLocaleString()}</time>
              </div>
              <div className="ce-audit__body">
                {entry.reason && <p style={{ margin: 0 }}>{entry.reason}</p>}
                {(entry.field || entry.old_value != null || entry.new_value != null) && (
                  <div className="ce-audit__field-change">
                    <strong>{entry.field}</strong>: {formatValue(entry.old_value)} →{" "}
                    {formatValue(entry.new_value)}
                  </div>
                )}
              </div>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
